import { connect } from 'react-redux';
import {
  importRoster,
  importRoute,
  newGroup,
  removeGroup,
  dispatchRemoveMemberFromGroup,
  editGroup,
  addMember,
  editMember,
  postGroupData,
  bulkPostGroupData,
  createQuestions,
  AddedQuestions,
  removeQuestion,
  requestTourquestions,
  selectEvent,
  newRoomType,
  addMultipleBidDetail,
  saveRoomPreferences,

 } from '../modules/tour';

import TourRosterTab from './TourRosterTab';

const mapDispatchToProps = {
  dispatchRemoveMemberFromGroup,
  importRoster,
  importRoute,
  newGroup,
  removeGroup,
  editGroup,
  addMember,
  editMember,
  postGroupData,
  bulkPostGroupData,
  createQuestions,
  AddedQuestions,
  removeQuestion,
  requestTourquestions,
  selectEvent,
  newRoomType,
  addMultipleBidDetail,
  saveRoomPreferences,
};

const mapStateToProps = state => ({
  tour: state.tours.selectedTour.tour,
  isLoading: state.tours.selectedTour.isLoading,
  addQuestion: state.tours.additionalQuestion,
  addedQuestion: state.tours.addQuestion,
  hotels: state.tours.hotels,
  selectedEvent: state.tours.selectedTour.selectedEvent,
});
const TourRosterTabContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(TourRosterTab);
export default TourRosterTabContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRosterTabContainer.js